import {
  getPage,
  getDetail,
  getClientPage,
  datevehicleInfoGroupswitchtypelimit,
  dateswitchtypelimit,
} from '@/api/accopenanalysisregulationserv'

export default {
  state: {
    state_ACCopenAnalysisRegulation_GetPageResult: null,
    state_ACCopenAnalysisRegulation_GetDetailResult: null,
    state_ACCopenAnalysisRegulation_GetClientPageResult: null,
    state_ACCopenAnalysisRegulation_DatevehicleInfoGroupswitchtypelimitResult: null,
    state_ACCopenAnalysisRegulation_DateswitchtypelimitResult: null,
  },
  mutations: {
    SET_ACCOPENANALYSISREGULATION_GETPAGE_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisRegulation_GetPageResult = rst;
    },
    SET_ACCOPENANALYSISREGULATION_GETDETAIL_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisRegulation_GetDetailResult = rst;
    },
    SET_ACCOPENANALYSISREGULATION_GETCLIENTPAGE_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisRegulation_GetClientPageResult = rst;
    },
    SET_ACCOPENANALYSISREGULATION_DATEVEHICLEINFOGROUPSWITCHTYPELIMIT_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisRegulation_DatevehicleInfoGroupswitchtypelimitResult = rst;
    },
    SET_ACCOPENANALYSISREGULATION_DATESWITCHTYPELIMIT_RESULT: (state, rst) => {
      state.state_ACCopenAnalysisRegulation_DateswitchtypelimitResult = rst;
    },
  },
  actions: {
    ACCopenAnalysisRegulationServ_GetPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISREGULATION_GETPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISREGULATION_GETPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisRegulationServ_GetDetail({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getDetail(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISREGULATION_GETDETAIL_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISREGULATION_GETDETAIL_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisRegulationServ_GetClientPage({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        getClientPage(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISREGULATION_GETCLIENTPAGE_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisRegulationServ_DatevehicleInfoGroupswitchtypelimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        datevehicleInfoGroupswitchtypelimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISREGULATION_DATEVEHICLEINFOGROUPSWITCHTYPELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISREGULATION_DATEVEHICLEINFOGROUPSWITCHTYPELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
    ACCopenAnalysisRegulationServ_Dateswitchtypelimit({commit}, {params, urlparams, extfunc}) {
      return new Promise((resolve, reject) => {
        dateswitchtypelimit(params, urlparams).then(response => {
          const rsp = response.data;
          if (rsp.code === 200) {
            commit('SET_ACCOPENANALYSISREGULATION_DATESWITCHTYPELIMIT_RESULT', rsp.data);
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams);
            }
            resolve(rsp);
          } else {
            commit('SET_ACCOPENANALYSISREGULATION_DATESWITCHTYPELIMIT_RESULT', rsp);
            reject(rsp.msg);
          }
        }).catch(error => {
          reject(error);
        })
      })
    },
  },
  getters:{
    get_ACCopenAnalysisRegulation_GetPageResult: state => {
      return state.state_ACCopenAnalysisRegulation_GetPageResult;
    },
    get_ACCopenAnalysisRegulation_GetDetailResult: state => {
      return state.state_ACCopenAnalysisRegulation_GetDetailResult;
    },
    get_ACCopenAnalysisRegulation_GetClientPageResult: state => {
      return state.state_ACCopenAnalysisRegulation_GetClientPageResult;
    },
    get_ACCopenAnalysisRegulation_DatevehicleInfoGroupswitchtypelimitResult: state => {
      return state.state_ACCopenAnalysisRegulation_DatevehicleInfoGroupswitchtypelimitResult;
    },
    get_ACCopenAnalysisRegulation_DateswitchtypelimitResult: state => {
      return state.state_ACCopenAnalysisRegulation_DateswitchtypelimitResult;
    },
  }
}